export default __webpack_public_path__ + "static/winter3-cdae013a98b4c7d6faee550eed3587bc.webp";